import StaffPerformanceCSVPreviewBaseColumnsStrategy from './StaffPerformanceCSVPreviewBaseColumnsStrategy'

export default function StaffPerformanceCSVPreviewOnlyUserColumnsStrategy() {}

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype = Object.create(StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype)

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.init = function(includeOtherUsersColumn, needSwitchToMe) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.init.call(this, includeOtherUsersColumn)
    this.needSwitchToMe = needSwitchToMe
    return this
}


StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.addMainHeaderRowCells = function(mainHeaderRow) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addMainHeaderRowCells.call(this, mainHeaderRow)

    let colTitle = ""
    if (this.needSwitchToMe) {
        colTitle = this.message("report.common.me")
    } else {
        colTitle = this.message("report.common.user")
    }

    this.addCell(mainHeaderRow, colTitle)
    if (!this.needSwitchToMe) this.addCell(mainHeaderRow, colTitle)
    if (this.includeOtherUsersColumn) this.addCell(mainHeaderRow, this.message("report.common.others"))
}

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function(colGroupingRow) {
    //do nothing
}

StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.prototype.getNumOfDataColumns = function() {
    let numOfDataColumns = 2
    if (!this.needSwitchToMe) numOfDataColumns++
    if (this.includeOtherUsersColumn) numOfDataColumns++

    return numOfDataColumns
}






// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewOnlyUserColumnsStrategy.js